import { JsonSchemaValidator } from "@common/json-schema-validator";
import { RtmpDestinationEntityRaw } from "../../interface";
import { rtmpDestinationEntityRaw } from "../../schema";
import { BaseEntity } from "../base.entity";

export class RtmpDestinationEntity extends BaseEntity<RtmpDestinationEntityRaw> {
  private static validator = JsonSchemaValidator.compile(
    rtmpDestinationEntityRaw
  );

  constructor(value: RtmpDestinationEntityRaw) {
    super(JsonSchemaValidator.assert(RtmpDestinationEntity.validator, value));
  }
}
